<template>
  <div class="logout">
      Redirect...
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
// @ is an alias to /src
export default {
  name: 'logout',
  methods: {
    ...mapMutations([
      'clearState'
    ]),
    redirect() {
      this.clearState()
      this.$router.replace('/login')
    }
  },
  mounted() {
    this.redirect();
  }
};
</script>